module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Cégep":"CEGEP","Filtre":"Filter","Liste des portes ouvertes":"List of open houses"}}')
  delete Component.options._Ctor
}
